import { jsx as n } from "react/jsx-runtime";
import { createContext as r, useContext as i } from "react";
const t = r(void 0), a = ({
  children: o,
  config: e
}) => /* @__PURE__ */ n(t.Provider, { value: { config: e }, children: o }), f = () => {
  const o = i(t);
  return o === void 0 ? { config: {
    featureFlags: (typeof window < "u" && window.__LAWCONNECT_CONFIG__ || { featureFlags: {} }).featureFlags
  } } : o;
};
function c() {
  const { config: o } = f();
  return o.featureFlags;
}
export {
  a as ConfigProvider,
  f as useConfig,
  c as useFeatureFlags
};
